<div class="team-container">
  <hr>
  <h2><a id="team" href="/#jesteer">Meet the team</a></h2>
  <p align="center">Please don't hesitate to reach out to us. (We're all for hire!)</p>
  <div class="team">
    <div class="member">
      <img src="../img/clare.jpeg" width="100px" alt="Clare Cerullo">
      <p><strong>Clare Cerullo</strong></p>
      <p><strong>Frontend Engineer</strong></p>
      <p><a href="https://www.linkedin.com/in/clarecerullo/">LinkedIn</a> | <a href="https://github.com/ClareCerullo">GitHub</a></p>
    </div>
    <div class="member">
      <img src="../img/tim.jpeg" width="100px" alt="Tim Ruszala">
      <p><strong>Tim Ruszala</strong></p>
      <p><strong>Backend Engineer</strong></p>
      <p><a href="https://www.linkedin.com/in/timruszala/">LinkedIn</a> | <a href="https://github.com/TimothyRuszala">GitHub</a></p>
    </div>
    <div class="member">
      <img src="../img/cha.jpeg" width="100px" alt="Charissa Ramirez">
      <p><strong>Charissa Ramirez</strong></p>
      <p><strong>Frontend Engineer</strong></p>
      <p><a href="https://www.linkedin.com/in/chawissa/">LinkedIn</a> | <a href="https://github.com/chawissa">GitHub</a></p>
    </div>
    <div class="member">
      <img src="../img/katie.png" width="100px" alt="Katie Janzen">
      <p><strong>Katie Janzen</strong></p>
      <p><strong>Backend Engineer</strong></p>
      <p><a href="https://www.linkedin.com/in/katie-janzen/">LinkedIn</a> | <a href="https://github.com/347Online">GitHub</a></p>
    </div>
  </div>
</div>


<style>
  h2 {
    text-align: center;
    margin-bottom: 1.5rem;
  }
  .team-container {
    margin-top: 8rem;
  }

  img {
    clip-path: circle(50px at center);
  }
  .team {
    display: flex;
    justify-content: center;
    gap: 10px;
    padding: 4rem;
    text-align: center;
  }
  .member {
    flex: 1;
  }
  hr {
    width: 80%;
    margin-left: 10%;
    margin-right: 10%;
    margin-bottom: 1.5rem;
    height: 1px;
    border-width:0;
    color: black;
    background-color: black;
  }
</style>